<template>
    <div
        class="
            scribble-container
            absolute
            top-0
            left-0
            z-[999]
            w-full
            h-[calc(100%-80px)]
        "
        ref="container"
    >
        <canvas
            :style="{ opacity: opacity }"
            ref="canvas"
            @mousedown="startDrawing"
            @mouseup="stopDrawing"
            @mousemove="draw"
            @mouseleave="stopDrawing"
        ></canvas>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const canvas = ref(null);
const container = ref(null);
const ctx = ref(null);
const isDrawing = ref(false);
const color = ref("#00ff00");
const opacity = ref(1);
const fadeInterval = ref(null);

const startDrawing = (event) => {
    clearTimeout(timeout); // Clear any existing fade-out timeout
    clearInterval(fadeInterval.value); // Clear any existing fade-out interval
    opacity.value = 1; // Reset opacity
    isDrawing.value = true;
    const { offsetX, offsetY } = event;
    ctx.value.globalAlpha = 1; // Ensure full opacity during drawing
    ctx.value.beginPath();
    ctx.value.moveTo(offsetX, offsetY);
    ctx.value.strokeStyle = color.value;
    ctx.value.lineWidth = 5;
};

let timeout = null;

const draw = (event) => {
    if (!isDrawing.value) return;
    clearTimeout(timeout); // Clear any existing fade-out timeout
    clearInterval(fadeInterval.value); // Clear any existing fade-out interval
    opacity.value = 1; // Reset opacity to 1
    const { offsetX, offsetY } = event;
    ctx.value.lineTo(offsetX, offsetY);
    ctx.value.stroke();
};

const stopDrawing = () => {
    if (!isDrawing.value) return;
    isDrawing.value = false;
    ctx.value.closePath();
    clearInterval(fadeInterval.value); // Clear any existing fade-out interval
    clearTimeout(timeout); // Clear any existing fade-out timeout

    // Start fade-out effect
    timeout = setTimeout(() => {
        startFadeOut();
    }, 6000);
};

const startFadeOut = () => {
    if (fadeInterval.value) clearInterval(fadeInterval.value);

    fadeInterval.value = setInterval(() => {
        opacity.value -= 0.05; // Decrease opacity gradually
        if (opacity.value <= 0) {
            clearCanvas(); // Clear canvas after fade-out
            clearInterval(fadeInterval.value);
        }
    }, 20); // Update opacity every 100ms
};

const clearCanvas = () => {
    ctx.value.clearRect(0, 0, canvas.value?.width, canvas.value?.height);
    opacity.value = 1;
};
// Dynamically resize the canvas to match the parent container
const resizeCanvas = () => {
    if (!canvas.value || !container.value) return;

    const { clientWidth, clientHeight } = container.value;

    // Resize the canvas
    canvas.value.width = clientWidth;
    canvas.value.height = clientHeight;
};

onMounted(() => {
    const canvasEl = canvas.value;
    ctx.value = canvasEl.getContext("2d");
    resizeCanvas(); // Resize canvas on mount
    window.addEventListener("resize", resizeCanvas); // Handle window resize
});

onUnmounted(() => {
    window.removeEventListener("resize", resizeCanvas); // Cleanup event listener
});
</script>

<style scoped>
.scribble-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

canvas {
    cursor: crosshair;
}

.controls {
    margin-top: 10px;
}

label {
    margin-right: 5px;
}
</style>
